/**
 * Configuration for Order Management
 * Maps step types from the wizard to edit step types
 */

import {RmcOrderIntakeStepType} from '../../orderIntake/config/stepTypes'

import {EditableFieldType} from './RmcOrderEditStepView'

/**
 * Mapping between RmcOrderIntakeStepType and EditableFieldType
 * Used to map wizard steps to editable steps in order management
 */
export const STEP_TYPE_TO_EDIT_TYPE: Record<RmcOrderIntakeStepType, EditableFieldType | null> = {
  [RmcOrderIntakeStepType.QUOTE]: EditableFieldType.QUOTE,
  [RmcOrderIntakeStepType.MATERIAL]: EditableFieldType.MATERIAL,
  [RmcOrderIntakeStepType.MIX_CHARACTERISTICS]: EditableFieldType.MIX_CHARACTERISTICS, // Mix characteristics configured in material step
  [RmcOrderIntakeStepType.QUANTITY]: EditableFieldType.QUANTITY,
  [RmcOrderIntakeStepType.USAGE]: EditableFieldType.USAGE,
  [RmcOrderIntakeStepType.UNLOADING_METHOD]: EditableFieldType.UNLOADING_METHOD,
  [RmcOrderIntakeStepType.INTERVALS]: EditableFieldType.INTERVALS,
  [RmcOrderIntakeStepType.DATE]: EditableFieldType.DATE,
  [RmcOrderIntakeStepType.TIME]: EditableFieldType.TIME,
  [RmcOrderIntakeStepType.DETAILS]: null // Details are edited directly in the overview
}

/**
 * Mapping from EditableFieldType to display labels
 * Function to get internationalized edit step labels
 */
export const getEditableFieldLabels = (
  t: (key: string, fallback: string) => string
): Record<EditableFieldType, string> => ({
  [EditableFieldType.QUOTE]: t('orderIntake.rmc.orderManagement.editSteps.labels.quote', 'Quote'),
  [EditableFieldType.MATERIAL]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.material',
    'Mix type'
  ),
  [EditableFieldType.MIX_CHARACTERISTICS]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.materialVariations',
    'Material Variations'
  ),
  [EditableFieldType.QUANTITY]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.quantity',
    'Quantity'
  ),
  [EditableFieldType.USAGE]: t('orderIntake.rmc.orderManagement.editSteps.labels.usage', 'Usage'),
  [EditableFieldType.UNLOADING_METHOD]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.unloadingMethod',
    'Unloading method'
  ),
  [EditableFieldType.INTERVALS]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.intervals',
    'Interval'
  ),
  [EditableFieldType.DATE]: t('orderIntake.rmc.orderManagement.editSteps.labels.date', 'Date'),
  [EditableFieldType.TIME]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.time',
    'Start time'
  ),
  [EditableFieldType.PO_NUMBER]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.poNumber',
    'PO Number'
  ),
  [EditableFieldType.DRIVER_INSTRUCTIONS]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.driverInstructions',
    'Driver Instructions'
  ),
  [EditableFieldType.ADDITIONAL_NOTES]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.additionalNotes',
    'Additional Notes'
  ),
  [EditableFieldType.RETARDER]: t(
    'orderIntake.rmc.orderManagement.editSteps.labels.retarder',
    'Retarder'
  )
})
